import { LoanStatusTypeVersion2, LoanSubStatusType } from "pages/dashboard/home/dashboardService";

interface LoanStatusData {
  label: {
    title: string;
    description: string;
  };
  isActive?: boolean;
  subStatus?: Record<LoanSubStatusType, LoanStatusData>;
}

export const data: Record<LoanStatusTypeVersion2, LoanStatusData> = {
  Unknown: {
    label: {
      title: "Unknown Status",
      description: "",
    },
  },
  Started: {
    label: {
      title: "Application Received",
      description: "We’ve received your information and have started our review.",
    },
  },
  Processing: {
    label: {
      title: "Processing",
      description: "We’re reviewing your documents and verifying your information.",
    },
  },
  InitialApproval: {
    label: {
      title: "Initial Approval",
      description: "You’re conditionally approved! We’ll guide you through the next steps.",
    },
  },
  ClearToClose: {
    label: {
      title: "Cleared-to-Close",
      description: "You’re nearly there! We’re prepping your final documents",
    },
  },
  Closed: {
    label: {
      title: "Closed",
      description: "You’re officially closed- congrats on your new home!",
    },
  },
  PreApproved: {
    label: {
      title: "Pre Approved",
      description: "Your application is pre-approved!",
    },
  },
};
